import langBn from './element_bn';
import translations from './translations';

export default {
  ...translations,
  ...langBn,
};
